import {Component, Injector, Input} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {SizeGroupSearchModel} from "../size-group-search.model";
import {SizeGroupSearchPageComponent} from "../size-group-search-page/size-group-search-page.component";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {SizeGroupEditPageComponent} from "../size-group-edit-page/size-group-edit-page.component";

@Component({
    selector: "wbo-size-group-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(SizeGroupSingleSelectEditControlComponent),
        provideSearchModel(SizeGroupSearchModel)
    ]
})
export class SizeGroupSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<SizeGroupSearchModel> {
    @Input() override hideAddOption: boolean = false;

    private _sellableId: number;

    constructor(model: SizeGroupSearchModel, injector: Injector) {
        super(model, injector, "id", "name");
        this.extendedSearchComponent = SizeGroupSearchPageComponent;
        this.extendedEditComponent = SizeGroupEditPageComponent;
    }

    get sellableId(): number {
        return this._sellableId;
    }

    @Input() set sellableId(value: number) {
        this._sellableId = value;
        this.model.filter[SizeGroupSearchModel.SELLABLE_ID_FILTER_NAME] = value;
        this.loadDataFromSearchModel();
    }
}
